import React, { useEffect, useState } from "react";
import { Card, Result, Button, Typography, Space, Alert } from "antd";
import { CloseCircleOutlined, HomeOutlined, ReloadOutlined } from "@ant-design/icons";
import { useSearchParams, useNavigate } from "react-router-dom";

const { Text } = Typography;

const ErrorView: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [errorDetails, setErrorDetails] = useState<{
    code?: string;
    message?: string;
  }>({});

  const amortizationId = searchParams.get("amortizationId");
  const errorCode = searchParams.get("error");
  const errorMessage = searchParams.get("message");

  useEffect(() => {
    setErrorDetails({
      code: errorCode || undefined,
      message: errorMessage || undefined
    });
  }, [errorCode, errorMessage]);

  const handleGoHome = () => {
    navigate("/perfil");
  };

  const handleRetryPayment = () => {
    if (amortizationId) {
      navigate(`/perfil`);
    } else {
      navigate("/perfil");
    }
  };

  const handleViewAccount = () => {
    navigate(`/perfil`);
  };

  const getErrorMessage = () => {
    if (errorDetails.message) {
      return errorDetails.message;
    }

    switch (errorDetails.code) {
      case "cancelled":
        return "El pago fue cancelado por el usuario.";
      case "declined":
        return "El pago fue rechazado. Por favor, verifique sus datos de pago.";
      case "timeout":
        return "El tiempo para completar el pago ha expirado.";
      case "insufficient_funds":
        return "Fondos insuficientes para completar la transacción.";
      case "invalid_card":
        return "Los datos de la tarjeta son inválidos.";
      default:
        return "Ocurrió un error durante el procesamiento del pago. Por favor, inténtelo nuevamente.";
    }
  };

  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      minHeight: "400px",
      padding: "20px"
    }}>
      <Card style={{ maxWidth: "500px", width: "100%" }}>
        <Result
          icon={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
          status="error"
          title="Error en el Pago"
          subTitle={
            <Space direction="vertical" size="small">
              <Text>{getErrorMessage()}</Text>
              {amortizationId && (
                <Text type="secondary">
                  Amortización #{amortizationId}
                </Text>
              )}
            </Space>
          }
          extra={[
            <Button 
              type="primary" 
              key="retry" 
              icon={<ReloadOutlined />}
              onClick={handleRetryPayment}
              style={{ marginRight: "8px" }}
            >
              Intentar Nuevamente
            </Button>,
            <Button 
              key="account" 
              onClick={handleViewAccount}
              style={{ marginRight: "8px" }}
            >
              Ver Estado de Cuenta
            </Button>,
            <Button 
              key="home" 
              icon={<HomeOutlined />} 
              onClick={handleGoHome}
            >
              Ir al Inicio
            </Button>,
          ]}
        />

        {errorDetails.code && (
          <Alert
            message="Detalles del Error"
            description={
              <Space direction="vertical" size="small">
                <Text>Código: {errorDetails.code}</Text>
                {errorDetails.message && (
                  <Text>Mensaje: {errorDetails.message}</Text>
                )}
              </Space>
            }
            type="error"
            showIcon
            style={{ marginTop: "16px" }}
          />
        )}

        <Card 
          size="small" 
          style={{ marginTop: "16px", backgroundColor: "#f5f5f5" }}
          title="¿Necesitas ayuda?"
        >
          <Space direction="vertical" size="small">
            <Text type="secondary">
              Si el problema persiste, puedes:
            </Text>
            <Text type="secondary">
              • Verificar los datos de tu tarjeta
            </Text>
            <Text type="secondary">
              • Contactar a tu banco
            </Text>
            <Text type="secondary">
              • Intentar con otro método de pago
            </Text>
            <Text type="secondary">
              • Contactar a nuestro soporte técnico
            </Text>
          </Space>
        </Card>
      </Card>
    </div>
  );
};

export default ErrorView;